import React from 'react';
import PropTypes from 'prop-types';
import {compose, graphql, withApollo} from 'react-apollo';
import {Button, Container, Modal, ModalBody, ModalHeader, ModalFooter, Input, Form, FormGroup} from 'reactstrap';
import {graphQLErrorProcesor} from "helpers/errors";
import {FormattedMessage} from "react-intl";
import RelativeDuration from "components/RelativeDuration";
import moment from 'moment';
import {generateUrl, routes} from "helpers/routes";
import {Link} from "react-router-dom";
import debug from 'helpers/debug';
import {withUser} from "helpers/login";
import {withRouter} from 'react-router';
import {confirmOnlineWarning} from "actions/onlineWarning";
import {connect} from "react-redux";

import DataQuery from 'gql/contactList.gql';
import OperatorQuery from 'gql/operator/operator.gql';
import NewContactSubscription from 'gql/contact/subscribeNew.gql';
import UpdateContactSubscription from 'gql/contact/subscribeUpdated.gql';
import EditNoteMutation from 'gql/contact/setVoiceNote.gql';
import CustomerQuery from 'gql/customer/customer.gql';
import Loading from "components/Loading";
import {formatPhone} from "helpers/phone";

class DataProvider extends React.Component {
    static propTypes = {
        children: PropTypes.node.isRequired,
        operatorQuery: PropTypes.object.isRequired,
        dataQuery: PropTypes.object,
        editNote: PropTypes.func.isRequired,
        onlineWarningRead: PropTypes.bool,
        confirmOnlineWarning: PropTypes.func.isRequired,
    };

    static callingStates = ['RINGING', 'UP'];

    componentWillMount() {
        this.setState({
            subscribing: false,
            activeCallModal: {
                open: false,
            },
            onlineWarningModal: {
                open: false,
            }
        });
    }

    componentWillReceiveProps(newProps) {
        if (!this.state.subscribing && newProps.dataQuery) {
            this.contactUpdateSubscription = newProps.dataQuery.subscribeContactUpdates();
            this.contactCreateSubscription = newProps.dataQuery.subscribeNewContacts();

            this.setState({subscribing: true});
        }

        if (this.state.subscribing && !newProps.dataQuery) {
            if (this.contactUpdateSubscription) {
                this.contactUpdateSubscription();
            }

            if (this.contactCreateSubscription) {
                this.contactCreateSubscription();
            }

            this.setState({subscribing: false});
        }

        if (
            typeof newProps.dataQuery !== "undefined" &&
            newProps.dataQuery.activeContact &&
            !this.state.activeCallModal.open &&
            this.state.activeCallModal.id !== newProps.dataQuery.activeContact.id &&
            newProps.dataQuery.activeContact.type === 'voice' &&
            DataProvider.callingStates.includes(newProps.dataQuery.activeContact.voice.state)
        ) {
            const contact = newProps.dataQuery.activeContact;
            this.setState({
                activeCallModal: {
                    open: true,
                    advertId: contact.profile.advert.id,
                    profileId: contact.profile.id,
                    id: contact.id,
                    note: contact.voice.note ? contact.voice.note : '',
                }
            });
        }

        if (
            newProps.operatorQuery.operator &&
            newProps.operatorQuery.operator.online &&
            (!this.props.operatorQuery || !this.props.operatorQuery.online) &&
            !newProps.onlineWarningRead
        ) {
            this.setState({
                onlineWarningModal: {
                    open: true
                }
            });
        }
    }

    componentWillUnmount() {
        if (this.contactUpdateSubscription) {
            this.contactUpdateSubscription();
        }

        if (this.contactCreateSubscription) {
            this.contactCreateSubscription();
        }

        this.setState({
            subscribing: false
        });
    }

    onNoteChange(event) {
        event.preventDefault();
        const value = event.target.value;

        const activeCallModal = Object.assign({}, this.state.activeCallModal);
        activeCallModal.note = value;

        this.setState({
            activeCallModal,
        });
    }

    setNote() {
        this.props.editNote({
            variables: {
                contact: this.state.activeCallModal.id,
                note: this.state.activeCallModal.note
            }
        }).then(() => {
            this.setState({activeCallModal: {open: false}});
        });
    }

    closeActiveCallModal() {
        const activeCallModal = this.state.activeCallModal;
        activeCallModal.open = false;
        this.setState({activeCallModal});
    }

    render() {
        let contact = null;

        if (this.props.dataQuery && this.props.dataQuery.adverts && this.state.activeCallModal.open) {
            contact = this.props.dataQuery.adverts.find(advert => (advert.id === this.state.activeCallModal.advertId))
                .profiles.find(profile => (profile.id === this.state.activeCallModal.profileId))
                .contacts.find(contact => (contact.id === this.state.activeCallModal.id));
        }

        const loading = this.props.dataQuery && !this.props.dataQuery.adverts;

        return (
            <Container fluid className="layout">
                {contact &&
                <Modal keyboard autoFocus isOpen modalClassName="modal-call"
                       toggle={::this.closeActiveCallModal}>
                    <ModalHeader toggle={::this.closeActiveCallModal}>
                        <FormattedMessage id="active_call_modal.title" defaultMessage="Active call"/>
                    </ModalHeader>
                    <ModalBody>
                        <div className="calling">
                            <div className="calling__person">
                                <img src={require('img/dummy.png')} alt="Customer"/>
                                <strong>{contact.profile.title}</strong>
                                <p>{formatPhone(contact.customerPhonenum)}</p>
                            </div>
                            <div className="calling__person">
                                <img src={contact.profile.advert.photoUrl} alt={contact.profile.advert.name}/>
                                <strong>{contact.profile.advert.name}</strong>
                            </div>
                            <div className="calling__time">
                                {contact.voice.state === 'RINGING' &&
                                <FormattedMessage id="call_state.ringing" defaultMessage="Ringing"/>
                                }

                                {contact.voice.state === 'FINISHED' &&
                                <FormattedMessage id="call_state.finished" defaultMessage="Finished"/>
                                }

                                {contact.voice.state === 'UP' &&
                                <RelativeDuration date={moment.unix(contact.voice.timeStarted)}/>
                                }
                            </div>
                        </div>

                        <p className="text-center">
                            <Link to={generateUrl(routes.conversations, {
                                customer: contact.profile.customer.id,
                                profile: contact.profile.id,
                                advert: contact.profile.advert.id,
                            })} className="btn btn-primary"
                                  onClick={::this.closeActiveCallModal}
                            >
                                <FormattedMessage id="active_call_modal.show_customer_info"
                                                  defaultMessage="Show customer info"/>
                            </Link>
                        </p>

                        <Form>
                            <FormGroup>
                                <FormattedMessage id="active_call_modal.note_placeholder" defaultMessage="Write a note"
                                                  children={message => (
                                                      <Input type="textarea" value={this.state.activeCallModal.note}
                                                             onChange={::this.onNoteChange} placeholder={message}
                                                      />
                                                  )}/>
                            </FormGroup>
                            <FormGroup className="text-right">
                                <Button onClick={::this.setNote} outline color="secondary">
                                    <FormattedMessage id="active_call_modal.submit" defaultMessage="Submit"/>
                                </Button>
                            </FormGroup>
                        </Form>
                    </ModalBody>
                </Modal>
                }

                <Modal keyboard autoFocus isOpen={this.state.onlineWarningModal.open} modalClassName="modal-small"
                       toggle={() => this.setState({onlineWarningModal: {open: false}})}>
                    <ModalHeader toggle={() => this.setState({onlineWarningModal: {open: false}})}>
                        <FormattedMessage id="online_warning_modal.title" defaultMessage="Warning"/>
                    </ModalHeader>
                    <ModalBody>
                        <FormattedMessage id="online_warning_modal.text" defaultMessage="Your online status will stay uninterrupted even if you close this window"/>
                    </ModalBody>
                    <ModalFooter>
                        <Button color="secondary" onClick={() => {this.setState({onlineWarningModal: {open: false}}); this.props.confirmOnlineWarning()}}>
                            <FormattedMessage id="button.ok" defaultMessage="OK"/>
                        </Button>
                    </ModalFooter>
                </Modal>

                {!loading &&
                <div id="content">
                    {this.props.children}
                </div>
                }

                {loading &&
                <Loading />
                }
            </Container>
        );
    }
}

export default compose(
    withRouter,
    withUser,
    withApollo,
    connect(
        (state) => ({
            onlineWarningRead: state.onlineWarning,
        }),
        (dispatch) => ({
            confirmOnlineWarning: () => dispatch(confirmOnlineWarning())
        })
    ),
    graphql(OperatorQuery, {
        name: 'operatorQuery',
        options: (props) => ({
            variables: {
                user: props.user, // Needs dependency on logged in user
            },
            fetchPolicy: 'network-only',
        })
    }),
    graphql(DataQuery, {
        name: 'dataQuery',
        options: props => ({
            skip: !props.operatorQuery.operator,
            variables: {
                operator: props.operatorQuery.operator ? parseInt(props.operatorQuery.operator.id, 10) : null,
                contactLimit: 1,
                contactOffset: 0,
                profileLimit: 10,
                profileOffset: 0,
            }
        }),
        props({dataQuery: {subscribeToMore, variables, refetch, ...rest}, ownProps}) {
            const client = ownProps.client;
            return {
                dataQuery: {
                    ...rest,
                    variables,
                    refetch,
                    subscribeNewContacts: () => {
                        return subscribeToMore({
                            document: NewContactSubscription,
                            variables: {
                                operator: variables.operator,
                            },
                            updateQuery: (prev, {subscriptionData}) => {
                                debug('New contact:');
                                debug(subscriptionData);
                                if (!subscriptionData) {
                                    return prev;
                                }

                                // Find advert
                                const newContact = Object.assign({}, subscriptionData.data.contact);
                                const adverts = prev.adverts.slice(0);
                                const advertIdx = adverts.findIndex(advert => (advert.id === newContact.profile.advert.id));

                                if (advertIdx === -1) { // If advert is not in list (It should be! - probably added from other source)
                                    refetch(); // force sync
                                    return prev;
                                }

                                // Assign
                                const advert = Object.assign({}, adverts[advertIdx]);
                                const profiles = advert.profiles.slice(0);

                                // Find or create profile
                                const profileIdx = profiles.findIndex(profile => (profile.id === newContact.profile.id));

                                if (profileIdx === -1) { // Profile does not exist yet
                                    // Update this query
                                    const advertLight = Object.assign({}, advert);
                                    delete advertLight.profiles;
                                    delete advertLight.numUnreadProfiles;
                                    const profile = {
                                        id: newContact.profile.id,
                                        title: newContact.profile.title,
                                        customer: Object.assign({}, newContact.profile.customer),
                                        numContacts: 1,
                                        numUnread: 1,
                                        totalVoiceTime: 0,
                                        receivedTextCount: newContact.type === 'voice' ? 0 : 1,
                                        receivedVoiceCount: newContact.type === 'voice' ? 1 : 0,
                                        lastContact: [newContact],
                                        contacts: [newContact],
                                        advert: advertLight,
                                        info: {
                                            __typename: "CustomerProfileInfo",
                                            byOperator: {},
                                            byCustomer: {},
                                        },
                                        notes: [],
                                        __typename: "CustomerProfile"
                                    };
                                    profiles.unshift(profile);
                                    advert.numUnreadProfiles++;

                                    // Check if customer query for this customer is loaded and if it is, add the profile to the list.
                                    try {
                                        const query = CustomerQuery;
                                        const variables = {
                                            customer: profile.customer.id,
                                            contactLimit: 50,
                                            contactOffset: 0
                                        };

                                        const data = client.readQuery({query, variables});
                                        data.customer.profiles.push(profile);
                                        client.writeQuery({query, variables, data});
                                    }
                                    catch (e) {}
                                }
                                else {
                                    const profile = Object.assign({}, profiles[profileIdx]);
                                    const contacts = profile.contacts.slice(0);
                                    contacts.unshift(newContact);
                                    profile.contacts = contacts;
                                    profile.numContacts++;
                                    if (newContact.directionReceived) {
                                        profile.numUnread++;
                                    }
                                    profiles[profileIdx] = profile;
                                    if (profile.numUnread === 1) {
                                        advert.numUnreadProfiles++;
                                    }

                                    try {
                                        const query = CustomerQuery;
                                        const variables = {
                                            customer: profile.customer.id,
                                            contactLimit: 50,
                                            contactOffset: 0
                                        };

                                        const data = client.readQuery({query, variables});
                                        const customerProfile = data.customer.profiles.find(p => (profile.id === p.id));
                                        customerProfile.contacts.unshift(newContact);
                                        if (newContact.directionReceived) {
                                            if (newContact.type === "voice") {
                                                customerProfile.receivedVoiceCount++;
                                            }
                                            else {
                                                customerProfile.receivedTextCount++;
                                            }
                                        }
                                        client.writeQuery({query, variables, data});
                                    }
                                    catch (e) {}
                                }

                                advert.profiles = profiles;
                                adverts[advertIdx] = advert;

                                const updateObj = {adverts: adverts};
                                // Update active contact if is voice contact
                                if (newContact.type === 'voice') {
                                    updateObj.activeContact = newContact;
                                }

                                return Object.assign({}, prev, updateObj);
                            }
                        });
                    },
                    subscribeContactUpdates: () => {
                        return subscribeToMore({
                            document: UpdateContactSubscription,
                            variables: {
                                operator: variables.operator
                            },
                            updateQuery: (prev, {subscriptionData}) => {
                                debug('Updated contact:');
                                debug(subscriptionData);

                                const contact = Object.assign({}, subscriptionData.data.contact);
                                if (contact.type === 'voice' && contact.voice.state === 'FINISHED') {
                                    const query = CustomerQuery;
                                    const variables = {
                                        customer: contact.profile.customer.id,
                                        contactLimit: 50,
                                        contactOffset: 0
                                    };

                                    const data = client.readQuery({query, variables});
                                    const customerProfile = data.customer.profiles.find(p => (contact.profile.id === p.id));
                                    customerProfile.totalVoiceTime += moment.unix(contact.voice.timeFinished).diff(moment.unix(contact.voice.timeStarted), 'seconds');
                                    client.writeQuery({query, variables, data});
                                }
                            }
                        });
                    }
                }
            }
        }
    }),
    graphql(EditNoteMutation, {name: 'editNote'}),
    graphQLErrorProcesor(['operatorQuery', 'dataQuery']),
)(DataProvider);


// WEBPACK FOOTER //
// ./src/containers/DataProvider/index.jsx